
export const PROJECT_COUNT = 5;
export const ITEM_SPACING = 4.8;
export const RADIUS = 10;
export const PROJECTS = [
  { 
    id: 0, 
    title: "Bella", 
    category: "Premium Kitchenware", 
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&w=1200&q=80" 
  },
  { 
    id: 1, 
    title: "Luxe", 
    category: "Architectural Estate", 
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80" 
  },
  { 
    id: 2, 
    title: "Vertex", 
    category: "Minimalist Objects", 
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&w=1200&q=80" 
  },
  { 
    id: 3, 
    title: "Nexus", 
    category: "Digital Solutions", 
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1200&q=80" 
  },
  { 
    id: 4, 
    title: "Prism", 
    category: "Spatial Design", 
    image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80" 
  },
];
